const getText = (value) =>
	String(value ?? '')
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.trim();

const getSetorLabel = (item = {}) =>
	String(
		item?.nome_exibicao ||
			item?.nomeExibicao ||
			item?.setorNome ||
			item?.identificador ||
			item?.nome ||
			item?.label ||
			item?.value ||
			'',
	).trim();

const getExplicitFloor = (item = {}) => {
	const value = item?.andar ?? item?.floor ?? item?.piso;
	if (value === '' || value === null || value === undefined) return null;

	const numericValue = Number(value);
	return Number.isFinite(numericValue) ? numericValue : null;
};

const extractFloorFromText = (value = '') => {
	const text = getText(value).toUpperCase();
	if (!text) return null;

	const subsoloMatch = text.match(/\bSUBSOLO(?:\s+([A-Z]))?\b/);
	if (subsoloMatch) {
		return subsoloMatch[1]
			? -(subsoloMatch[1].charCodeAt(0) - 64)
			: -1;
	}

	const matches = [...text.matchAll(/(?:^|\s)(-?\d+)\s*([A-Z])?(?=\s|$)/g)];
	if (matches.length === 0) return null;

	const match = matches[matches.length - 1];
	const floor = Number(match[1]);
	if (!Number.isFinite(floor)) return null;

	return floor;
};

export const getSetorFloor = (item = {}) =>
	getExplicitFloor(item) ??
	extractFloorFromText(item?.identificador) ??
	extractFloorFromText(getSetorLabel(item));

const compareFloors = (floorA, floorB) => {
	if (floorA === null && floorB === null) return 0;
	if (floorA === null) return 1;
	if (floorB === null) return -1;

	const isBasementA = floorA < 0;
	const isBasementB = floorB < 0;

	if (isBasementA && isBasementB) {
		return Math.abs(floorA) - Math.abs(floorB);
	}
	if (isBasementA !== isBasementB) return isBasementA ? -1 : 1;
	return floorA - floorB;
};

export const compareSetoresPorAndar = (a = {}, b = {}) => {
	const floorComparison = compareFloors(
		getSetorFloor(a),
		getSetorFloor(b),
	);
	if (floorComparison !== 0) return floorComparison;

	return getSetorLabel(a).localeCompare(getSetorLabel(b), 'pt-BR', {
		numeric: true,
		sensitivity: 'base',
	});
};

export const sortSetoresPorAndar = (items = []) =>
	[...(Array.isArray(items) ? items : [])].sort(compareSetoresPorAndar);

export const formatAndarEscala = (andar, andaresDisponiveis = []) => {
	const numericFloor = Number(andar);
	if (!Number.isFinite(numericFloor)) return String(andar || '-');

	if (numericFloor < 0) {
		const subterraneos = Array.from(
			new Set(
				(Array.isArray(andaresDisponiveis)
					? andaresDisponiveis
					: []
				)
					.map(Number)
					.filter((value) => Number.isFinite(value) && value < 0),
			),
		).sort((a, b) => Math.abs(a) - Math.abs(b));

		if (subterraneos.length <= 1) return 'Subsolo';

		const index = subterraneos.indexOf(numericFloor);
		const suffixIndex = index >= 0 ? index : Math.abs(numericFloor) - 1;
		return `Subsolo ${String.fromCharCode(65 + Math.max(0, suffixIndex))}`;
	}

	return `${numericFloor}º andar`;
};
